// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { message, Typography } from 'antd'
import { Redirect, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
//import GoogleLogin from 'react-google-login'
import GrabLogo from 'assets/images/grab-logo.svg'
import { withRouter } from 'react-router'
import MaskLoading from 'components/MaskLoading'
import './PageLogin.less'
import { useGoogleLogin } from '@react-oauth/google';
import GoogleButtonNormal from '../assets/images/btn_google_signin_light_normal_web@2x.png';
import GoogleButtonFocused from '../assets/images/btn_google_signin_light_focus_web@2x.png';
import axios from 'axios'

function Login({ auth, location, loginAsync }) {
  const [hover, setHover] = useState(false);

  const googleOnError = (errorResponse) => {
    console.log(errorResponse)
    message.error("Failed to login with google.")
  }

  const googleOnSuccess = async (signinResponse) => {
      const accessToken = signinResponse.access_token
      const { data } = await axios(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const googleResponse = { accessToken: accessToken, profileObj: data };
      loginAsync(googleResponse)
  }

  const googleLogin = useGoogleLogin({
      onSuccess: signinResponse => googleOnSuccess(signinResponse),
      onError: errorResponse => googleOnError(errorResponse),
      flow: 'implicit',
  });

  // Redirect when already login
  if (auth.isAuthorized) {
    // If has redirect param in querystring, try using this path as the login redirect
    if (location.search.includes('redirect')) {
      const redirect = location.search.split('redirect=')[1]
      return <Redirect to={redirect} />
    }
    // Then try using state.from set in <PrivateRoute> component as the login redirect location
    const { state } = location
    if (state && state.from) {
      return <Redirect to={state.from} />
    }
    return <Redirect to='/upload' />
  }

  return (
    <div className='login' style={{ marginTop: 64 }}>
      <div className='container'>
        <p>
          <img className='logo' alt='grab logo' src={GrabLogo} />
        </p>
        <Typography.Title>Karta Camera {window.TRAVIS_BUILD_NUMBER || ''}</Typography.Title>
          {/*
          <GoogleLogin
            disabledStyle={{ opacity: 1 }}
            clientId={GOOGLE_CLIENT_ID}
            onSuccess={handleOAuth2Login}
            onFailure={handleOAuth2Login}
            scope='profile email'
            disabled={auth.loading}
          >
            Login with Google
          </GoogleLogin>
          */}
          
          <button className="google-login" 
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              onClick={() => googleLogin()}>
              {hover? (
                  <img className="google-login-button" src={GoogleButtonFocused} alt={"google signin focused"} />
              ) : (
                  <img className="google-login-button" src={GoogleButtonNormal} alt={"google signin"} />
              )}
          </button>
      </div>
      {auth.loading && <MaskLoading />}
    </div>
  )
}

Login.propTypes = {
    // react-router
  location: PropTypes.shape({
    search: PropTypes.string.isRequired, // is empty string when no querystring in URL
    state: PropTypes.shape({
      // A location object, set in  <PrivateRoute>
      from: PropTypes.object
    })
  }).isRequired,
  // redux
  auth: PropTypes.shape({
    isAuthorized: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired
  }).isRequired,
  loginAsync: PropTypes.func.isRequired
}

export default connect(
  state => ({ auth: state.auth }),
  dispatch => dispatch.auth
)(Login);
